import axios from "utils/axios";

export const ESTIMATES_ROUTE = `${process.env.REACT_APP_API_DOMAIN}/api/v1/estimates`;

export const getAllEstimates = () =>
  axios.get(ESTIMATES_ROUTE);